'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _minusButton = require('../../../img/minus-button.png');

var _minusButton2 = _interopRequireDefault(_minusButton);

var _plusButton = require('../../../img/plus-button.png');

var _plusButton2 = _interopRequireDefault(_plusButton);

var _cancelButton = require('../../../img/cancel-button.png');

var _cancelButton2 = _interopRequireDefault(_cancelButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Counter = function (_React$Component) {
    _inherits(Counter, _React$Component);

    function Counter(props) {
        _classCallCheck(this, Counter);

        var _this = _possibleConstructorReturn(this, (Counter.__proto__ || Object.getPrototypeOf(Counter)).call(this, props));

        _this.state = {
            selectValue: '1',
            min: 0,
            max: 0
        };

        _this.increment = _this.increment.bind(_this);
        _this.decrement = _this.decrement.bind(_this);
        return _this;
    }

    _createClass(Counter, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            this.setState({
                selectValue: this.props.currentValue,
                min: this.props.min,
                max: this.props.max
            });
        }
    }, {
        key: 'increment',
        value: function increment(e) {
            var oldVal = this.state.selectValue;

            // there is no maximum qty limit
            // let max    = this.state.max;
            // if(oldVal < max){
            this.setState({ selectValue: oldVal + 1 });
            this.props.callbackParent(oldVal + 1);
            // }
        }
    }, {
        key: 'decrement',
        value: function decrement(e) {
            var oldVal = this.state.selectValue;
            var min = this.state.min;
            if (oldVal > min) {
                this.setState({ selectValue: oldVal - 1 });
                this.props.callbackParent(oldVal - 1);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'btn-group1 ctr', role: 'group', 'aria-label': '...' },
                _react2.default.createElement(
                    'button',
                    { type: 'button', className: 'btn counter-button btn-button-link', onClick: this.decrement, tabIndex: 0 },
                    _react2.default.createElement('img', { src: _minusButton2.default, className: 'minusButton', alt: "Decrease Item Quantity" })
                ),
                _react2.default.createElement(
                    'button',
                    { type: 'button', className: 'btn btn-mid', tabIndex: -1 },
                    this.state.selectValue
                ),
                _react2.default.createElement(
                    'button',
                    { type: 'button', className: 'btn btn-inc counter-button btn-button-link', onClick: this.increment, tabIndex: 0 },
                    _react2.default.createElement('img', { src: _plusButton2.default, className: 'plusButton', alt: "Increase Item Quantity" })
                )
            );
        }
    }]);

    return Counter;
}(_react2.default.Component);

exports.default = Counter;


//////////////////
// WEBPACK FOOTER
// ./src/components/generic/Counter.jsx
// module id = 485
// module chunks = 0